import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import logo from './google-analytics-logo.png';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
}));

const handleRedirect = () => {
  const isProd = Boolean(window.location.hostname === 'pub.adireto.com');
  let link = isProd ? "http://auth.adireto.com:3001/" : "http://auth-staging.adireto.com:3001/";
  window.location.href = `${link}analyticsAuthRequest?siteId=${localStorage.getItem('publisher-active')}`;
};

export default function AnalyticsIntegration(props) {
  const classes = useStyles();
  return (
    <>
    <PageTitle title="Integrations"/>
    <br/>
    <Paper className={classes.paper}>
      <Grid container spacing={0}>
        <Grid item xs={3}>
          <img src={logo} alt="logo" height="150px"/>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h5">Google Analytics Reporting API</Typography>
          <Typography variant="h6">Connect your google analytics to improve our statistics</Typography>
          <br/>
          <br/>
          <Button color="primary" variant="contained" onClick={handleRedirect}>MANAGE</Button>
        </Grid>
      </Grid>
    </Paper>
    </>
  );
}